import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const base = API_BASE_URL;

/** 1. GET the list of top-level "Configuration For" categories */
export const getAllConfigs = () =>
    axios.get(`${base}/Accounts/GetAllConfigs`);

/** 2. GET the "Code Type" list (ConfigurationCategory/ConfigurationName pairs) under a Configuration For */
export const getCodes = (code) =>
    axios.get(`${base}/Accounts/GetCodes`, { params: { code } });

/** 3. GET the underlying master [Type] tied to a specific ConfigFor + Code Type combination */
export const getCheckConfigType = ({ code, codetext, codefor }) =>
    axios.get(`${base}/Accounts/GetCheckconfigtype`, { params: { code, codetext, codefor } });

/** 4. GET the selectable master values (cost centres, DCA, SDCA, IT, roles, employees, etc.) for the "All Code" dropdown */
export const getAllCodes = ({ code, codetext, codefor }) =>
    axios.get(`${base}/Accounts/GetAllcodes`, { params: { code, codetext, codefor } });

/** 5. GET the saved configuration grid for a given Configuration For */
export const getConfigDetails = (code) =>
    axios.get(`${base}/Accounts/GetConfigdetails`, { params: { code } });

/** 6. POST save a new page level configuration entry */
export const savePageLevelConfig = ({ configfor, Code, CodeValue, AllCode, RoleID, Createdby }) =>
    axios.post(`${base}/Accounts/Saveplcdetails`, { configfor, Code, CodeValue, AllCode, RoleID, Createdby });

/** 7. POST check whether this Configuration For / Code Type combination is already configured (locked) */
export const checkExistPending = ({ Code, AllCodeval }) =>
    axios.post(`${base}/Accounts/Checkexistpending`, { Code, AllCodeval });
